import { TeamActions } from './actions'
import { TeamGetters } from './getters'
import { TeamMutations } from './mutations'
import { TeamState } from './state'

export const TEAM_NAMESPACE = 'team'

export const Team = {
  namespaced: true,
  state: TeamState,
  actions: TeamActions,
  mutations: TeamMutations,
  getters: TeamGetters,
}
